import { Component, Prop, Watch, Emit, Vue } from 'vue-property-decorator';
// @ is an alias to /src
import axios, {AxiosResponse, AxiosError} from 'axios';
import store from '@/store';
import $ from 'jquery';

@Component
export default class HomeFavoritelist extends Vue {
  private name = 'homegavoritelist';
  private list: HotelDetail[] = [];
  private firstItemsLength = 6;
  private length: number|null = null;
  private isRemoveEdit = false;
  private isOpend = false;
  get favorites() {
    return this.$store.getters['favorites/hotels'];
  }
  get showMore() {
    if (this.list.length > this.firstItemsLength) {
      return true;
    } else {
      return false;
    }
  }
  @Emit()
  private async getMore() {
    if (this.isOpend) {
      this.isOpend = false;
    } else {
      this.isOpend = true;
    }
    this.$nextTick(() => {
      const list: any = this.$refs.list;
      if (!list) {
        return;
      }
      const $list: any = $(list);
      if (this.isOpend) {
        $list.find('.item:hidden').stop().slideDown();
      } else {
        $list.find('.item:gt(5)').stop().slideUp();
      }
    });
  }
  @Emit()
  private setList(list: HotelDetail[]): void {
    this.list = this.list.concat(list);
  }
  @Emit()
  private async getEntries() {
    const lang = this.$store.getters['auth/lang'];
    const hotels = this.favorites.join(',');
    // console.log(this.$store.getters['auth/token'])
    if (hotels.length > 0) {
      const result = await axios({
        method: 'get',
        url: `/api/wp-json/31corp/v1/hotels?hotel=${encodeURI(hotels)}&lang=${lang}`,
        headers: { Authorization: 'Bearer ' + this.$store.getters['auth/token']},
      })
      .then( (response: AxiosResponse<ApiHotels>) => {
        this.setList(response.data.hotels);
        return true;
      })
      .catch( (e: AxiosError) => {
        console.log(e);
        return false;
      });
    }
    return this.list;
  }
  @Emit()
  private edit(): void {
    if (this.isRemoveEdit) {
      this.isRemoveEdit = false;
    } else {
      this.isRemoveEdit = true;
    }
  }
  @Watch('$store.state.favorites.hotels', { deep: true })
  private onChangeFavoritesStatus(newHotels: string[], oldHotels: string[]) {
    const removeHotels: string[] = oldHotels.filter((itemNew) => {
      if (newHotels.indexOf(itemNew) === -1) {
        return itemNew;
      }
    });
    this.list = this.list.filter((hotel: HotelDetail) => {
      const removeFlg = (slug: string) => {
        if (removeHotels.indexOf(slug)) {
          return false;
        } else {
          return true;
        }
      };
      if (!removeFlg(hotel.slug)) {
        return hotel;
      }
    });
  }
}
